export const environment = {
  environmentName: 'Staging',

  production: false,

  graphQLEndpoint: "/graphql",
  subscriptionEndpoint: "wss://api.stage-v3.standortmonitor.net/graphql",
  serverUrl: "https://api.stage-v3.standortmonitor.net",
  posthogKey: 'phc_HDZXkj0MExg0KR9avtZtIXTHn60HsBbZX2b0e1GIkoD',
  posthogHost: 'https://eu.i.posthog.com',

  librarySlicePersistence: 'api' as 'api' | 'local',

  /** Old product menus. Set to false to switch to the top-down / bottom-up navigation. */
  legacyNavigation: true,
};
